import BaseModule from "~/vuex/modules/base-module";
import StringHelper from "~/helpers/StringHelper";
import ObjectHelper from "~/helpers/ObjectHelper";

let Cruises = {...BaseModule};

Cruises.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/cruises?fieldset=mas';

    state.endpoints['codeTitles'] = '/api/cruises/codes-titles';
    state.endpoints['lastSailDate'] = '/api/cruises/last-date';
    state.allCodes = [];

    state.lastDate = null;
    state.sort = {};
    state.sort.month = {
        data: {},
        meta: {}
    };
    state.sort.ship = {
        data: {},
        meta: {}
    };
    state.sort.meta = {
        data: {},
        meta: {}
    };

    // state.moduleBindings = {
    //     ship: 'ships/set',
    //     departure_port: 'ports/set',
    //     arrival_port: 'ports/set',
    //     cabin_availability_summary: 'cabinAvailabilitySummary/set',
    //     lead_price: 'leadPrices/set',
    //     grade_availability_summary: 'gradeAvailabilitySummary/set',
    //     available_cruise_cabins: 'availableCruiseCabins/set'
    // };

    return state;
};

Cruises.getters.cruiseCodes = function(state) {
    return function(filterString = null) {
        return state.allCodes.filter(code => StringHelper.contains(code, filterString));
    }
};

Cruises.getters.lastDate = function(state) {
    return state.lastDate;
}

Cruises.getters.sortMeta = state => sortType => state.sort[sortType].meta;

Cruises.getters.shipConfiguration = function(state, getters, rootState, rootGetters) {
    return function(cruiseCode) {
        if (getters['exists'](cruiseCode)) {
            return rootGetters['shipConfigurations/get'](getters['get'](cruiseCode).ship_configuration_id);
        }

        return null;
    }
}

Cruises.getters.ship = function(state, getters, rootState, rootGetters) {
    return function(cruiseCode) {
        let shipConfiguration = getters['shipConfiguration'](cruiseCode);

        if (ObjectHelper.isObject(shipConfiguration)) {
            return rootGetters['ships/get'](shipConfiguration.ship_code);
        }

        return null;
    }
}

Cruises.getters.getCruiseIdFromCruiseCode = function(state) {
    return function (cruiseCode) {
        for (let cruiseId in state.all) {
            if (state.all.hasOwnProperty(cruiseId)) {
                if (state.all[cruiseId].code.toLowerCase() === cruiseCode.toLowerCase()) {
                    return cruiseId;
                }
            }
        }
        return null;
    }
}

Cruises.mutations.setCruiseCodes = function(state, data) {
    Vue.set(state, 'allCodes', data);
};


Cruises.mutations.setLastDate = function(state, data) {
    Vue.set(state, 'lastDate', data);
};

Cruises.actions.getCruiseCodesWithTitles = async function({state, commit, getters}, refresh = false) {
    if (getters['cruiseCodes']().length === 0 || refresh) {
        let endpoint = state.endpoints['codeTitles'];
        let response = await this.axios.get(endpoint);

        if (response.status === 200) {
            commit('setCruiseCodes', response.data);
        }
    }
};

Cruises.actions.getLastCruiseDate = async function({commit, getters}) {
    let lastDate = getters['lastDate'];
    let endpoint = state.endpoints['lastSailDate'];

    if (!lastDate) {
        let response = await this.axios.get(endpoint);

        if (response.status === 200) {
            commit('setLastDate', response.data);
        }
    }
};

export default Cruises;
